module.exports = __webpack_public_path__ + "static/img/avatar.b4c223a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/comm/assets/avatar.jpg
// module id = QkHY
// module chunks = 9